import {
  getModule,
  Module,
  VuexModule,
  Mutation,
} from 'vuex-module-decorators';
import { PaymentMethod } from '@stripe/stripe-js';
import { store } from './store';

@Module({
  dynamic: true,
  name: 'stripe',
  namespaced: true,
  stateFactory: true,
  store,
})
export class StripeModule extends VuexModule {
  public selectedPlanId: string = '';
  public selectedCardId: string = '';
  public selectedSepaDirectDebitId: string = '';

  public plans: Array<any> = [];
  public cards: Array<PaymentMethod> = [];
  public sepaDirectDebits: Array<PaymentMethod> = [];

  @Mutation
  public SET_PLANS(plans: Array<any>) {
    this.plans = plans;
  }

  @Mutation
  public SET_CARDS(cards: Array<PaymentMethod>) {
    this.cards = cards;
  }

  @Mutation
  public SET_SEPA_DIRECT_DEBITS(sepaDirectDebits: Array<PaymentMethod>) {
    this.sepaDirectDebits = sepaDirectDebits;
  }

  @Mutation
  public SET_SELECTED_PLAN_ID(planId: string) {
    this.selectedPlanId = planId;
  }

  @Mutation
  public SET_SELECTED_CARD_ID(cardId: string) {
    this.selectedCardId = cardId;
  }

  @Mutation
  public SET_SELECTED_SEPA_DIRECT_DEBIT_ID(sepaDirectDebitId: string) {
    this.selectedSepaDirectDebitId = sepaDirectDebitId;
  }
}

export const stripeState = getModule(StripeModule);
